module.exports = __webpack_public_path__ + "static/assets/5b351b350ad5af2bef26f11d6c053c71.gif";